import React from 'react';

export default ({data}) => (
  <div className="intro">
    <h2>{data.name}</h2>
  </div>
)
